jQuery(document).ready(function ($) {

    $("select").each(function (index) {
        $(this).selectric({
            openOnFocus: false,
            disableOnMobile: false,
            nativeOnMobile: false,
            arrowButtonMarkup: '<b class="button" aria-hidden="true"></b>',
        });
    });
    
    $(".selectric").attr("tabindex", "0");

    $(".selectric-wrapper").each(function (index) {
        let id = $(this).find('select').attr('id');
        $(this).find('.selectric-input').attr('id',id+'input').wrap( '<label for="'+id+'input"></label>' );
    });

    

    jQuery(".validation_message").attr("role", "alert");
    jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
        jQuery(".validation_message").attr("role", "alert");
    })


    $('[data-fancybox="gallery"]').fancybox({
        buttons: [
            "close"
        ],
        loop: true,
        protect: true,
        infobar: false,
        btnTpl: {
            arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
                '<div><svg xmlns="http://www.w3.org/2000/svg" width="33" height="62" viewBox="0 0 33 62" fill="none"><path d="M31 60L2 31L31 2" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
                "</button>",

            arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
                '<div><svg xmlns="http://www.w3.org/2000/svg" width="33" height="62" viewBox="0 0 33 62" fill="none"><path d="M2 60L31 31L2 2" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
                "</button>",
            close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M31 1L1 31M1 1L31 31" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
                "</button>",
        }
    });

    $(".faq_section_inner_wrapper .heading_and_content .content").hide();
    $(".faq_section_inner_wrapper .heading_and_content .faq_heading").on("click", function (e) {
        e.preventDefault();

        if ($(this).next().is(":visible")) {
            $(this).removeClass("active");
            $(this).next().slideUp();
        } else {
            $(".faq_section_inner_wrapper .heading_and_content .content").slideUp();
            $(".faq_section_inner_wrapper .heading_and_content .faq_heading ").removeClass("active");
            $(this).addClass("active");
            $(this).next().slideDown();
        }
    });


    $("body").on("click", ".site_header__nav .menu-wrapper > .menu-item > .sub-menu-toggle", function (event) {
        event.preventDefault();
        var self = $(this);
        $(this).parent().toggleClass('active');
        $(this).next().toggleClass('show_submenu');
        $('body').toggleClass('stop_scroll');
        setTimeout(function () {
            $('.wrap_sub-menu > .sub-menu.lvl1').remove();
            $('.wrap_sub-menu li.menu-item.active').removeClass('active');
            self.next().removeClass('mega_menu');
        }, 240);
    });

    $("body").on("click", ".site_header__nav .show_submenu > .sub-menu > .menu-item:not(.active) > .sub-menu-toggle", function (event) {
        event.preventDefault();
        var self = $(this); // .removeClass('show_submenu')
        self.parent().parent().parent().removeClass('show_submenu').hide();
        $('.wrap_sub-menu > .sub-menu.lvl1').remove();
        $('.wrap_sub-menu li.menu-item.active').removeClass('active');
        $(this).next().clone().appendTo($(this).parent().parent().parent());
        // $(this).parent().addClass('active').parent().parent().delay(60).addClass('mega_menu').fadeIn(0);
        // setTimeout(function () {
        //     self.parent().parent().parent().addClass('show_submenu');
        // }, 120);
        $(this).parent().addClass('active').parent().parent().addClass('mega_menu').show();
        // setTimeout(function () {
        // }, 120);
        self.parent().parent().parent().addClass('show_submenu');
    });

    $("body").on("click", ".site_header__nav .menu-wrapper .menu-item_search > .btn_link", function (event) {
        event.preventDefault();
        $('body').toggleClass('stop_scroll');
        $(this).parent().toggleClass('active');
        $('.site_header__nav .search_form_wrapper').toggleClass('open');
        if ($('.site_header__nav .search_form_wrapper').hasClass("open")) {
            $(this).attr("aria-expanded", "true");
            $(this).attr("aria-label", "open search");
        } else {
            $(this).attr("aria-expanded", "false");
            $(this).attr("aria-label", "close search");
        }
    });

    $("body").on("click", ".site_header__nav .menu-button-container > .button", function (event) {
        event.preventDefault();
        $('body').toggleClass('stop_scroll');
        $(this).toggleClass('active');
        $('.site_header__nav .search_form_wrapper').toggleClass('active');
        $(this).closest('.navigation').toggleClass('menu_open');
    });


    $(".mobile-menu__wrapper .menu li.menu-item > a").on('click', function (event) {

        var parentLevel = $(this).parents('ul').length - 1;
        var currentMenu = $(this).closest('ul');
        var currentListItem = $(this).parent('li');
        var parentMenu = $('.level-' + parentLevel);
        var subMenu = $(this).next('ul');

        if (currentListItem.hasClass('back')) {
            event.preventDefault();
            // back button hit	
            currentMenu.removeClass('active');
            parentMenu.removeClass('hidden');
        } else if (currentListItem.children('ul').length > 0) {
            event.preventDefault();
            // menu item has children - expand the menu
            subMenu.toggleClass('active');
            currentMenu.addClass('hidden');
        }
    });

    $(".resources_slider").each(function (index) {
        var slider = $(this).find('.resources_slider_inner_right_main');
        $slick_prev = '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none"><title>Previous</title><g clip-path="url(#clip0_2525_639)"><path class="disable" d="M0.587288 24.4993C0.587288 11.2923 11.2937 0.585938 24.5007 0.585938C37.7077 0.585938 48.4141 11.2923 48.4141 24.4993C48.4141 37.7063 37.7077 48.4127 24.5007 48.4127C11.2937 48.4127 0.587288 37.7063 0.587288 24.4993Z" fill="#ffabdc"/><path d="M9.78137 24.7295L23.0135 38.0064C23.1341 38.1271 23.3295 38.1281 23.4512 38.0064L26.6122 34.8455C26.7328 34.7248 26.7328 34.5295 26.6122 34.4088L19.2387 27.0354H39.002C39.1728 27.0354 39.3105 26.8966 39.3105 26.7268V22.2976C39.3105 22.1268 39.1718 21.9891 39.002 21.9891H19.2376L26.6335 14.5921C26.7542 14.4715 26.7542 14.2761 26.6335 14.1555L23.4726 10.9945C23.3519 10.8739 23.1555 10.8739 23.0349 10.9945L9.78031 24.2939C9.65968 24.4145 9.65968 24.6099 9.78031 24.7305L9.78137 24.7295Z" fill="#090909"/></g><defs><clipPath id="clip0_2525_639"><rect width="47.8268" height="47.8268" fill="white" transform="matrix(-1 0 0 1 48.4141 0.585938)"/></clipPath></defs></svg></button>';
        $slick_next = '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none"><title>Next</title><g clip-path="url(#clip0_2525_644)"><path class="disable color" d="M48.4127 24.4993C48.4127 11.2923 37.7063 0.585938 24.4993 0.585938C11.2923 0.585938 0.585938 11.2923 0.585938 24.4993C0.585938 37.7063 11.2923 48.4127 24.4993 48.4127C37.7063 48.4127 48.4127 37.7063 48.4127 24.4993Z" fill="#A3F985"/><path d="M39.2186 24.7295L25.9865 38.0064C25.8659 38.1271 25.6705 38.1281 25.5488 38.0064L22.3878 34.8455C22.2672 34.7248 22.2672 34.5295 22.3878 34.4088L29.7613 27.0354H9.99797C9.82717 27.0354 9.68945 26.8966 9.68945 26.7268V22.2976C9.68945 22.1268 9.82823 21.9891 9.99797 21.9891H29.7624L22.3665 14.5921C22.2458 14.4715 22.2458 14.2761 22.3665 14.1555L25.5274 10.9945C25.6481 10.8739 25.8445 10.8739 25.9651 10.9945L39.2197 24.2939C39.3403 24.4145 39.3403 24.6099 39.2197 24.7305L39.2186 24.7295Z" fill="#090909"/></g><defs><clipPath id="clip0_2525_644"><rect width="47.8268" height="47.8268" fill="white" transform="translate(0.585938 0.585938)"/></clipPath></defs></svg></button>'
        slider.slick({
            dots: false,
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: true,
            speed: 800,
            cssEase: 'ease',
            prevArrow: $slick_prev,
            nextArrow: $slick_next,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    infinite: true,
                }
            }]
        });
    });

    if (jQuery(".resources_slider_inner_right_main_item.slick-slide").length > 0) {
        jQuery(".resources_slider_inner_right_main_item.slick-slide").attr("tabindex", '-1');
    }
    if (jQuery(".resources_slider_inner_right_main_item_inner_cat_item a").length > 0) {
        jQuery(".resources_slider_inner_right_main_item_inner_cat_item a").attr("tabindex", '-1');
    }

    jQuery(document).on("click", ".team_inner_main_list .team_item_inner[data-lity]", function () {
        setTimeout(function () {
            $('.lity').addClass('team_popup_open');
            $('body').addClass('lity-active');
        });
    });

    jQuery(document).on('lity:close', function (event, instance) {
        $('.lity').removeClass('video_popup_open');
        $('body').removeClass('video_popup_active');
    });

    if ($(window).width() < 768) {
        if (!$('.team_inner_main_list.with_slider').hasClass("slick-initialized")) {
            $('.team_inner_main_list.with_slider').slick({
                dots: false,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 2000
            });
        }
    }

    offsetLeft();

    jQuery(document).on("keydown", function (e) {
        if (e.keyCode == 13) {
            debugger;
            if (jQuery(e.target).closest(".team_item").length > 0 && !e.target.classList.contains("lity-close")) {
                var link1 = jQuery(e.target).closest(".team_item").find(".popup_link").attr("href");
                var lity1 = new lity(link1);
                setTimeout(function () {
                    jQuery('.lity').addClass('team_popup_open');
                    jQuery('body').addClass('lity-active');
                });
            } else if(e.target.classList.contains("lity-close")) {
                jQuery("[data-lity-close]").click();
            }
        }
    })
});

jQuery(window).on("resize", function () {
    offsetLeft();
    if (jQuery(window).width() < 768) {
        if (!jQuery('.team_inner_main_list.with_slider').hasClass("slick-initialized")) {
            jQuery('.team_inner_main_list.with_slider').slick({
                dots: false,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                variableWidth: true,
                autoplay: true,
                autoplaySpeed: 2000
            });
        }
    } else {

        if (jQuery('.team_inner_main_list.with_slider').hasClass("slick-initialized")) {
            jQuery('.team_inner_main_list.with_slider').slick("unslick");
            jQuery('.team_inner_main_list.with_slider').removeAttr("style");
        }
    }
});

function offsetLeft() {
    if ((jQuery('.resources_slider_inner_right_main').length > 0)) {
        var resourcesoffset = jQuery('.resources_slider_inner_right_main').offset(),
            resourceswindWidth = jQuery(window).width();
        jQuery('.resources_slider_inner_right_main').css('width', (resourceswindWidth - resourcesoffset.left));
    }
    if (jQuery(window).width() < 768) {
        if ((jQuery('.team_inner_main_list.with_slider').length > 0)) {
            var boxesoffset = jQuery('.team_inner_main_list.with_slider').offset(),
                boxeswindWidth = jQuery(window).width();
            jQuery('.team_inner_main_list.with_slider').css('width', (boxeswindWidth - boxesoffset.left));
        }
    }
}